module.exports = __webpack_public_path__ + "c46b4bc7ce5fa6c8ace4ad67975bb9fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/14.jpg
// module id = 1340
// module chunks = 47